/** The Firebase Auth tenant resource and policy shared by every tenant feature. */
export const tenantResource = {
  key: "firebase-tenant",
  displayLabel: "Firebase Auth tenant",
  kind: "firebase.tenant",
} as const;

// local + preview managed; prod is configured outside the env CLI.
export const tenantEnvironments = {
  local: { mode: "managed" },
  preview: { mode: "managed" },
  production: {
    mode: "not-applicable",
    note: "Production resource exists outside preview-style setup.",
  },
} as const;
